import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanApiURL, eramanHost, magpHost } from "~/Utils";
import { fields } from "../constants";
import { useMenuHeader } from "../Header.hook";

export const EditMenuHeader = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useMenuHeader(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      name: dataById
        ? dataById.payload.name
        : editData
          ? editData?.[0]?.name
          : "",
      field_malay_title: dataById ? dataById.payload.field_malay_title : editData ? editData?.[0].field_malay_title : "",
      field_mandarin_title: dataById ? dataById.payload.field_mandarin_title : editData ? editData?.[0].field_mandarin_title : "",
      field_category: dataById
        ? dataById.payload.field_category
        : editData
          ? editData?.[0]?.field_category
          : "",
      field_common_image: dataById?.payload
        ? decodeHTML([
          {
            uid: "-1",
            name: "field_common_image.png",
            status: "done",
            url: dataById?.payload?.field_common_image,
          },
        ])
        : decodeHTML([
          {
            uid: "-1",
            name: "field_common_image.png",
            status: "done",
            url: editData?.[0]?.field_common_image,
          },
        ]),
      published: dataById ? dataById.payload.published : editData ? editData?.[0].published : "",
    },
    fields: fields.menuHeader,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {

    let imageKeys: any = [
      "field_common_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) { }
    }

    const payload = {
      action: action,
      method: method,
      module: "Header",
      subModule: `menuHeader`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === 'UPDATE' && { id: editData?.[0]?.tid || dataById?.payload?.tid }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Menu Header`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === 'update'}` ? `${eramanHost}/api/newmodulebanner/${editData?.[0]?.tid || dataById?.payload?.tid}` : `${eramanHost}/api/create/newmodulebanner`,
            `${query.get("editId") || query.get("type") === 'update' ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === 'update' ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
